import { useEffect } from 'react';
import { Platform } from 'react-native';

type Callback = () => void;

const useBeforeUnload = (callback: Callback): void => {
  useEffect(() => {
    const handleBeforeUnload = (): void => {
      if (typeof callback === 'function') {
        callback();
      }
    };

    if (Platform.OS === 'web') {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      if (Platform.OS === 'web') {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    };
  }, [callback]);
};

export default useBeforeUnload;
